import { ExchangeEstimateRes } from '@kr/components/exchange/models';

export const mockExchangeEstimateRes: ExchangeEstimateRes = {
  estimatedNetworkFee: {
    amount: 1,
    symbol: 'U',
  },
  estimationId: '123',
  expiresAt: 123,
  totalValueToSend: {
    amount: 1,
    symbol: 'T',
  },
  operationFee: {
    amount: 1,
    symbol: 'R',
  },
  rate: 0.00038,
  valueToReceive: {
    amount: 1,
    symbol: 'G',
  },
};
